import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const resourceLinkSchema = z.object({
	link: z.url({ hostname: z.regexes.domain }),
	name: ZodStringNullable,
	ticketId: ZodStringNullable,
});

export type ResourceLinkFormSchema = z.infer<typeof resourceLinkSchema>;
